export const INVALID_CREDENTIALS = 'INVALID_CREDENTIALS';



export const prodStemDomain = 'https://www.acceleratelearning.com';
